module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', _vm._l((_vm.product.donationtypes), function(donationtype) {
    return _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == donationtype),
        expression: "type == donationtype"
      }],
      key: donationtype,
      staticClass: "donation-widget"
    }, _vm._l((_vm.product.dollarhandles[donationtype]), function(handle, index) {
      return _c('li', {
        key: index,
        staticClass: "dollar-handle-container",
        class: {
          'active': handle.amount == _vm.dollarhandle
        }
      }, [_c('div', {
        staticClass: "selector"
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.dollarhandle),
          expression: "dollarhandle"
        }],
        attrs: {
          "disabled": (_vm.formWizardCurrentStep != 0),
          "type": "radio",
          "name": 'handle-widget-' + donationtype
        },
        domProps: {
          "value": handle.amount,
          "checked": _vm._q(_vm.dollarhandle, handle.amount)
        },
        on: {
          "change": function($event) {
            _vm.dollarhandle = handle.amount
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount"
      }, [_vm._v("\n            $" + _vm._s(parseInt(handle.amount)) + "\n          ")])]), _vm._v(" "), _c('span', {
        staticClass: "selector-image",
        style: ('background-image: url(' + handle.img + ')')
      })]), _vm._v(" "), _c('div', {
        staticClass: "description"
      }, [_c('h4', [_c('span', {
        on: {
          "click": function($event) {
            _vm.updateDollarHandle(handle.amount)
          }
        }
      }, [_vm._v(_vm._s(handle.header))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(handle.text))])])])
    }))
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32ad82aa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/DonationWidget.vue
// module id = 780
// module chunks = 0